import { Injectable } from '@angular/core';
import { PHBHPApiService } from './ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class PHBHPListApiService { 

  constructor(private service: PHBHPApiService) { }

  getInstitutionsbyId(id, roleId) {
    if(roleId != 3){
      return this.service.getApi('institutions/GetInstitutionsByIds/' + id, true);
    } else {
      return this.service.getApi('institutions/GetInstitutionByGroupId/' + id, true);
    }
  }

  CreateDeviceInfo(data) {
    return this.service.postApi('PushNotification/CreateNotification', data, true);
  }

  CreateUserImage(data) {
    return this.service.postFileApi('users/SaveImage', data, true);
  }

  getUserImage() {
    return this.service.getApi('users/GetProfileImages', true);
  }

    getUserImageById(id) {
    return this.service.getApi('users/GetUserProfileImageById/'+ id, true);
  }
  // deleteUserImage(id) {
  //   return this.service.deleteApi('UserProfileUploader/' + id, true);
  // }
  updateUserImage(id, data) {
    return this.service.putFileApi('users/UpdateImage/' + id, data, true);
  }
  profileUpdate(id, data) {
    return this.service.postFileApi('users/userProfile/' + id, data, true);
  }
  getTermsAndconditions(templateType,languageCode){
    return this.service.getApi(`Users/GetTemplate/${templateType}/${languageCode}`, true);
  }
  deleteTermsAndconditions(id,forceDelete){
    var selectedLanguage = localStorage.getItem('selectedlanguage');
    return this.service.deleteApi(`UserProfile/PolicyDisAgreed/${id}/${forceDelete}/${selectedLanguage}`, true);
  }

  getUserIsActive(userId: number) {
    return this.service.getApi('users/GetUserIsActive/' + userId, true);
  }

  getIsEvaluationAccessible(userId: number) {
    return this.service.getApi('users/IsEvaluationAccessible/' + userId, true);
  }
}

